import React, { useEffect } from 'react';
import { Controller, Control } from 'react-hook-form';
import { CurrencySelector } from '../../../components/common/CurrencySelector';
import { SettlementTypes } from "../Types";
import { getCurrencyAbbreviation, getCurrencyList } from "country-currency-map";
import { capitalizeCurrencyCode, enhancedGetCountryByAbbreviation, getNormalizedCurrencyName, normalizeCurrencyCode } from '../../../utils/helpers';

interface CurrencySelectorProps {
    countryValue: string;
    control: Control<SettlementTypes>;
    setValue: any;
}

export const SettlementCurrencySelector: React.FC<CurrencySelectorProps> = ({
    countryValue,
    control,
    setValue
}) => {

    const currencyOptions = getCurrencyList()
    const allCurrencyOptions = currencyOptions.map(currency => {
        const code = normalizeCurrencyCode(currency.abbr) ?? currency.abbr;
        return {
            value: code,
            label: code,
            fullName: getNormalizedCurrencyName(code) ?? currency.name,
        };
    });

    const getCountryCurrency = (countryCode: string): string => {
        let currency
        try {
            const countryName = enhancedGetCountryByAbbreviation(capitalizeCurrencyCode(countryCode))
            currency = getCurrencyAbbreviation(countryName)
            return normalizeCurrencyCode(currency) || '';
        } catch (error) {
            console.error('Error getting currency for country:', error);
            return '';
        }
    };

    useEffect(() => {
        const defaultCurrency = getCountryCurrency(countryValue);
        if (defaultCurrency) {
            setValue('currency', defaultCurrency, {
                shouldValidate: true,
                shouldDirty: true
            });
        }
    }, [countryValue]);

    return (
        <Controller
            name="currency"
            control={control}
            rules={{ required: "Currency is required" }}
            render={({ field, fieldState: { error } }) => (
                <div>
                    <CurrencySelector
                        countries={allCurrencyOptions}
                        selectValue={field.value || ''}
                        onSelectChange={(value) => {
                            field.onChange(value);
                            setValue('currency', value, {
                                shouldValidate: true,
                                shouldDirty: true
                            });
                        }}
                        styleForOnboardingSettlement={true}
                    />
                    {error && <span className="text-red-500 text-sm">{error.message}</span>}
                </div>
            )}
        />
    );
};